export enum enumIncotermsType {
  FCA = 1,
  DAT = 2,
  FOB = 3,
  CPT_CFR = 4,
}
